import styles from "./styles.module.scss";
import { ReviewItem } from "./ReviewItem";
import { ProblemsSolutionProps } from "./type";

export const ProblemsSolution = ({
  type,
  productProblems,
  activeIndex,
}: ProblemsSolutionProps) => {
  const activeProblem = productProblems[activeIndex];

  if (!activeProblem) {
    return <div className={styles.empty}>No data available</div>;
  }

  return (
    <div className={styles.box}>
      <div className={styles.content}>
        <div className={styles.header}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M0 22H23.999"
              stroke={type === "problem" ? "#FE5858" : "#8AFF6C"}
              strokeWidth="2"
            />
            <path
              d={
                type === "problem"
                  ? "M1 4L8 11L13 6L23 16M23 16H16M23 16V9"
                  : "M1 16L8 9L13 14L23 4M23 4H16M23 4V11"
              }
              stroke={type === "problem" ? "#FE5858" : "#8AFF6C"}
              strokeWidth="2"
            />
          </svg>
          <h2>{type === "problem" ? "Problem" : "Solution"}</h2>
        </div>
        {type === "problem" ? (
          <>
            <span className={styles.additional}>{activeProblem.title}</span>
            <div className={styles.reviewsTray}>
              {activeProblem.problems.map((problem) => (
                <ReviewItem
                  key={problem.id}
                  name={problem.name}
                  value={problem.value}
                  color={problem.color}
                  backgroundColor={problem.backgroundColor}
                />
              ))}
            </div>
          </>
        ) : (
          <p className={styles.solutionText}>{activeProblem.solution}</p>
        )}
      </div>
    </div>
  );
};
